const ORDER_RECEIVED = (state,order) => {
    state.order = order;
    state.loaded = true;
    state.needsPaymenRetry =  order && order.paymentType && order.paymentType.status == 35
    state.isAccessable = order.status < 20 || order.status > 30;
    state.waitingForGeneration = order.orderItems.flatMap(f => f.vouchers).some(f => !f.generated);
}

const ORDER_NOT_FOUND = (state) => {
    state.loaded = true;
    state.isAccessable = false;
}

const ORDER_CLAIMED = (state) => {
    state.order.isUnclaimed = false;
}

export default {
    ORDER_RECEIVED,
    ORDER_NOT_FOUND,
    ORDER_CLAIMED
  };